import React, { ReactElement, useState, useEffect, useCallback, } from 'react';
import { DI, DIProps } from '../../../../../Core';
import { TextField, ContextualSaveBar, Banner, BlockStack, Grid, Text, ButtonGroup, Button, Divider, InlineStack, Icon, Link, Card, RadioButton } from '@shopify/polaris';
import { Switch } from 'antd';
import useContextualSaveBar, { isAdminLoggedIn } from '../../../Panel/index';
import { RefreshMajor } from '@shopify/polaris-icons';
import { getLastSyncInformation } from '../../ConfigHelper';
import { RenderSkeletonInventorySetting } from '../../skeleton/skeleton';
import { useTranslation } from "react-i18next";
interface Props extends DIProps {
    defaultAttributes: any;
    data: any;
    syncNecessaryInfo: () => void;
    syncConnectorInfo: () => void;
}
interface TemplateProps {
    id: string;
    numberOfProductsAssigned: number;
}

export const compareArrays = (a: string[], b: string[]) =>
    a.length === b.length && a.every((element, index) => b.includes(element));

export const defaultInventorySettings: any = {
    "data_type": "inventory_settings",
    "inventory_settings": true,
    "continue_selling": {
        "enabled": true,
        "value": "999"
    },
    "effective_inventory": {
        "enabled": false,
        "type": "none",
        "value": ""
    },
    "inactivate_product": false,
    "warehouses": [],
};

export const defaultContextualSavebarData = {
    inventory_settings_switcher: false,
    continue_selling_switcher: false,
    continue_selling: false,
    effective_inventory_switcher: false,
    effective_inventory_type: false,
    effective_inventory: false,
    inactivate_product_switcher: false,
    warehouses: false,
}

export const defaultInventoryErrors: any = {
    effective_inventory: false,
    fixed_inventory: false,
    reserved_inventory: false,
    threshold_inventory: false,
    warehouses: false,
}

function InventorySettings(props: Props): ReactElement {
    const { t } = useTranslation();
    const { showSaveBar, hideSaveBar } = useContextualSaveBar(props);
    const [pageSkeleton, setPageSkeleton] = useState<boolean>(true);
    const [inventorySettings, setInventorySettings] = useState<any>(JSON.parse(JSON.stringify(defaultInventorySettings)));
    const [savedInventorySettings, setSavedInventorySettings] = useState<any>(JSON.parse(JSON.stringify(defaultInventorySettings)));
    const [showContextualSaveBar, setShowContextualSaveBar] = useState<boolean>(false);
    const [saveLoader, setSaveLoader] = useState<boolean>(false);
    const [getLoader, setGetLoader] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({ ...defaultInventoryErrors });
    const [contextualSaveBarData, setContextualSaveBarData] = useState<any>(JSON.parse(JSON.stringify(defaultContextualSavebarData)));
    const warehouseOptionsFromRedux = [...props?.redux?.current?.source?.warehouses];
    const [lastSync, setLastSync] = useState('')


    const onSettingsEnabledOrDisabled = (val: boolean) => {
        onInventorySettingsChange1("inventory_settings", "", val, false);
        // if (!val) {
        //     let tempErrors = JSON.parse(JSON.stringify(errors));
        //     tempErrors['inventory_fulfillment_latency'] = false;
        //     tempErrors['fixed_inventory'] = false;
        //     tempErrors['threshold_inventory'] = false;
        //     tempErrors['reserved_inventory'] = false;
        //     tempErrors['warehouses'] = false;
        //     setErrors(JSON.parse(JSON.stringify(tempErrors)));
        // }
        let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
        if (JSON.stringify(savedInventorySettings['inventory_settings']) != JSON.stringify(val)) tempContextualSaveBarData['inventory_settings_switcher'] = true;
        else tempContextualSaveBarData['inventory_settings_switcher'] = false;

        //contextual save bar
        if (!val) {
            // tempContextualSaveBarData['continue_selling_switcher'] = false
            // tempContextualSaveBarData['continue_selling'] = false
            // tempContextualSaveBarData['effective_inventory_switcher'] = false
            // tempContextualSaveBarData['effective_inventory_type'] = false
            // tempContextualSaveBarData['effective_inventory'] = false
            // tempContextualSaveBarData['inactivate_product_switcher'] = false
            // tempContextualSaveBarData['warehouses'] = false;
        }
        setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));
    }

    const onInventorySettingsChange1 = (key: string, subKey: string, value: any, switcher: boolean) => {
        let tempInventorySettings: any = JSON.parse(JSON.stringify(inventorySettings));
        if (subKey) {
            tempInventorySettings[key][subKey] = value;
        }
        else {
            tempInventorySettings[key] = value
        }
        setInventorySettings(JSON.parse(JSON.stringify(tempInventorySettings)));
    }

    //warehouse cases commented
    function getActivatedWarehouses(propsWarehouse: any) {
        let activatedWarehouses: any = [];
        Object?.values(propsWarehouse)?.map((warehouse: any, index: number) => {
            if (warehouse?.active) {
                activatedWarehouses.push(warehouse);
            }
        })
        return activatedWarehouses;
    }

    //warehouse cases commented
    function filterDefaultWarehouse(propsWarehouse: any, savedWarehouse: any) {
        let tempWarehouse: any = [];
        let activatedWarehouses: any = [];
        Object?.values(propsWarehouse)?.map((warehouse: any, index: number) => {
            if (warehouse?.active) {
                activatedWarehouses.push(warehouse);
                if (savedWarehouse && Array.isArray(savedWarehouse) && savedWarehouse.includes(warehouse?.id)) {
                    // if (savedWarehouse.includes(warehouse?.id)) {
                    tempWarehouse.push(warehouse?.id);
                    // }
                }
                else if (savedWarehouse == "all") tempWarehouse.push(warehouse?.id);
            }
        })
        if (activatedWarehouses.length == 1) {
            tempWarehouse = [];
            tempWarehouse.push(activatedWarehouses[0]['id']);
        }
        return tempWarehouse;
    }

    const getLastInventorySyncDate = () => {
        let data = getLastSyncInformation(props, 'inventory');
        data.then((res: any) => {
            if (res?.error) props.error(t(res?.error) ?? t('Could not get Last Sync'));
            else setLastSync(res?.date ?? '')
        })
    }

    const getInventorySettings = async () => {
        let { success, data, message } = await props.di.POST('connector/config/getConfig', {
            group_code: ["inventory"]
        });
        setPageSkeleton(false);
        setGetLoader(false)
        if (success && data?.[0]?.['group_code'] == "inventory" && data?.[0]?.['value'] && Object.keys(data?.[0]?.['value'])?.length > 0) {
            let tempInventorySettings = JSON.parse(JSON.stringify(inventorySettings));
            let dataValue = data?.[0]?.['value'];
            // let dataValue = removeStaleValues(JSON.parse(JSON.stringify(data?.[0]?.['value']))); 
            if (dataValue?.hasOwnProperty('data_type')) tempInventorySettings['data_type'] = dataValue?.data_type
            if (dataValue?.hasOwnProperty('inventory_settings')) tempInventorySettings['inventory_settings'] = dataValue?.inventory_settings
            if (dataValue?.hasOwnProperty('continue_selling')) tempInventorySettings['continue_selling'] = dataValue?.continue_selling
            if (dataValue?.hasOwnProperty('effective_inventory')) tempInventorySettings['effective_inventory'] = dataValue?.effective_inventory
            if (dataValue?.hasOwnProperty('inactivate_product')) tempInventorySettings['inactivate_product'] = dataValue?.inactivate_product
            if (dataValue?.hasOwnProperty('inventory_fulfillment_latency')) tempInventorySettings['inventory_fulfillment_latency'] = dataValue?.inventory_fulfillment_latency
            if (dataValue?.hasOwnProperty('warehouses')) {
                let filterWarehouseData = filterDefaultWarehouse(props?.redux?.current?.source?.warehouses, dataValue?.warehouses);
                tempInventorySettings['warehouses'] = filterWarehouseData;
            }
            setInventorySettings(JSON.parse(JSON.stringify(tempInventorySettings)));
            setSavedInventorySettings(JSON.parse(JSON.stringify(tempInventorySettings)));
        }
        // else props.error(t("Oops! Some error occured while getting inventory settings."));
    }

    const validator = () => {
        let hasError: boolean = false;
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (inventorySettings.inventory_settings) {
            if (inventorySettings.effective_inventory.enabled) {
                if (inventorySettings.effective_inventory.type == "none") {
                    if (!hasError) hasError = true;
                    tempErrors.effective_inventory = true;
                }
                else {
                    if (inventorySettings.effective_inventory.value == '' || inventorySettings.effective_inventory.value == 0) {
                        if (!hasError) hasError = true;
                        if (inventorySettings.effective_inventory.type == 'fixed') {
                            tempErrors.fixed_inventory = true;
                        }
                        else if (inventorySettings.effective_inventory.type == 'reserved') {
                            tempErrors.reserved_inventory = true;
                        }
                        else if (inventorySettings.effective_inventory.type == 'threshold') {
                            tempErrors.threshold_inventory = true;
                        }
                    }
                }

            }
            tempErrors.warehouses = inventorySettings.warehouses.length === 0;
            if (!hasError) hasError = inventorySettings.warehouses.length === 0;
        }
        return { hasError, errorsObj: tempErrors }
    }

    const removeStaleValues = (obj: any) => {
        let updatedData: any = JSON.parse(JSON.stringify({ ...defaultInventorySettings, ...obj }));
        if (!updatedData.inventory_settings) {
            updatedData = JSON.parse(JSON.stringify({ ...defaultInventorySettings, inventory_fulfillment_latency: updatedData?.inventory_fulfillment_latency ?? '', warehouses: updatedData.warehouses }));
            updatedData['inventory_settings'] = false;
        }
        else {
            if (!updatedData?.effective_inventory.enabled) {
                updatedData.effective_inventory.value = JSON.parse(JSON.stringify(defaultInventorySettings.effective_inventory.value));
            }
        }
        return updatedData;
    }

    const filterEditedData = (original: any, changed: any) => {
        const allSettings = Object.keys(defaultInventorySettings);
        const myObj: any = {};
        allSettings.forEach((setting: string) => {
            if (JSON.stringify(changed[setting]) != JSON.stringify(original[setting])) {
                myObj[setting] = changed[setting];
            }
        });
        return myObj;
    }

    const prepareBackendData = () => {
        let updatedPreparedData = removeStaleValues(JSON.parse(JSON.stringify(inventorySettings)));
        const editedData = JSON.parse(JSON.stringify(filterEditedData(savedInventorySettings, updatedPreparedData)));

        if (editedData?.continue_selling?.enabled && (editedData?.continue_selling?.value === '' || editedData?.continue_selling?.value == 0)) editedData.continue_selling.value = '999';
        let backendData = [
            {
                data: editedData,
                group_code: "inventory"
            }
        ];
        return backendData;
    }

    const saveInventorySettings = () => {
        setSaveLoader(true);
        const { hasError, errorsObj } = validator();
        if (!hasError) {
            let backendData = prepareBackendData();
            props.di.POST('connector/config/saveConfig', {
                "data": backendData
            }).then((response: any) => {
                setShowContextualSaveBar(false);
                setContextualSaveBarData(JSON.parse(JSON.stringify(defaultContextualSavebarData)));
                setSaveLoader(false);
                if (response?.success) {
                    props.success(t("Inventory settings saved successfully."));
                    setGetLoader(true);
                    getInventorySettings();
                    getLastInventorySyncDate();
                    setErrors(JSON.parse(JSON.stringify(defaultInventoryErrors)));
                }
                else { //api call mein agar koi error hogi
                    props.error(t("Oops! Some error occured while saving inventory settings."));
                }
            })
        }
        else {
            props.error(t("Some information is missing or wrong, kindly check them before proceeding."));
            setErrors(JSON.parse(JSON.stringify(errorsObj)));
            setSaveLoader(false);
        }
    }

    const handleDiscardBtn = () => {
        setPageSkeleton(true);
        setErrors(JSON.parse(JSON.stringify(defaultInventoryErrors)));
        setShowContextualSaveBar(false);
        setInventorySettings(JSON.parse(JSON.stringify(defaultInventorySettings)));
        setGetLoader(true);
        getInventorySettings();
        getLastInventorySyncDate();
    }

    function fillWareHouseSettings() {
        let warehouseOptionsFromRedux: any = [...props?.redux?.current?.source?.warehouses];
        let activatedWarehouses: any = warehouseOptionsFromRedux.map((obj: any) => {
            if (obj?.active) {
                return obj?.id
            }
        });
        setInventorySettings({
            ...inventorySettings,
            warehouses: activatedWarehouses
        })
    }

    useEffect(() => {
        setGetLoader(true);
        fillWareHouseSettings();
        getInventorySettings();
        getLastInventorySyncDate();
        return () => {
            if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) hideSaveBar();
            setContextualSaveBarData({});
            setErrors(JSON.parse(JSON.stringify(defaultInventoryErrors)));
        };
    }, []);

    useEffect(() => {
        let show = false;
        Object.values(contextualSaveBarData).map(val => {
            if (val) show = true;
        });
        setShowContextualSaveBar(show);
    }, [contextualSaveBarData]);

    const updateWarehouses = (checked: boolean, warehouseId: any) => {
        let savedWarehouses = JSON.parse(JSON.stringify(inventorySettings.warehouses));
        if (checked) savedWarehouses.push(warehouseId);
        else savedWarehouses.splice(savedWarehouses.indexOf(warehouseId), 1);
        setInventorySettings({ ...inventorySettings, warehouses: JSON.parse(JSON.stringify(savedWarehouses)) });
        let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
        if (!compareArrays(JSON.parse(JSON.stringify(savedWarehouses)), JSON.parse(JSON.stringify(savedInventorySettings['warehouses'])))) tempContextualSaveBarData['warehouses'] = true;
        else tempContextualSaveBarData['warehouses'] = false;
        setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));
    }

    //warehouse cases commented
    const renderWarehouses = () => {
        let warehouseMarkup: any = [];
        warehouseMarkup = warehouseOptionsFromRedux.map((obj: any, idx: number) => {
            return (
                <InlineStack gap="200" wrap={false} key={idx}>
                    <Switch className='switcherBtn' id={`inventory_Switch_Warehouse_${obj?.id}`} size="small" checked={inventorySettings.warehouses.includes(obj?.id)} disabled={!obj?.active || !inventorySettings.inventory_settings || saveLoader || getLoader
                        || getActivatedWarehouses(warehouseOptionsFromRedux).length == 1
                    } onChange={(e) => { updateWarehouses(e, obj?.id) }} />
                    <div className='Custom-Stack-Item--fill'>
                        {obj?.active ?
                            <Text id={`inventory_Text_Warehouse_${obj.name}`} as='p' fontWeight="semibold">{!obj?.active ? `${obj.name} ${(obj.address1 != undefined && obj.address1 != null && obj.address1 != '') ? '(' + obj.address1 + ')' : ''}` + t("(deactivated on shopify)") : `${obj.name} ${(obj.address1 != undefined && obj.address1 != null && obj.address1 != '') ? '(' + obj.address1 + ')' : ''}`}</Text> : <Text id={`inventory_Text_Warehouse_${obj.name}`} as='p' tone="subdued">{!obj?.active ? `${obj.name} ${(obj.address1 != undefined && obj.address1 != null && obj.address1 != '') ? '(' + obj.address1 + ')' : ''}` + t("(deactivated on shopify)") : `${obj.name} ${(obj.address1 != undefined && obj.address1 != null && obj.address1 != '') ? '(' + obj.address1 + ')' : ''}`}</Text>}
                    </div>
                </InlineStack>
            );
        });
        return warehouseMarkup
    }

    //Contextual Save Bar of App Bridge
    if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) {
        let savebar_options: any = {
            loading: saveLoader,
        };
        if (showContextualSaveBar) {
            showSaveBar(handleDiscardBtn, saveInventorySettings, { ...savebar_options });
        } else hideSaveBar();
    }
    return <>
        {pageSkeleton ? RenderSkeletonInventorySetting() : <>
            {
                showContextualSaveBar && (process.env.REACT_APP_PROD === "0" ||
                    isAdminLoggedIn()) && (
                    <ContextualSaveBar
                        message="Unsaved changes"
                        saveAction={{
                            onAction: () => saveInventorySettings(),
                            loading: saveLoader,
                            disabled: false,
                        }}
                        discardAction={{
                            onAction: () => { handleDiscardBtn() },
                        }}
                    />
                )
            }
            <BlockStack gap="500">
                <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }} >
                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }} >
                        <BlockStack gap="200">
                            <Text variant="headingMd" as="h6" id='inventory_Text_InventorySettings'>
                                {t("Inventory Settings")}
                            </ Text>
                            <Text as="p" fontWeight="regular" tone='subdued' id='inventory_Text_Description'>
                                {t("Manage your inventory to establish a time frame for processing and shipping orders, set fixed, custom, and threshold inventory levels, and manage the removal of out-of-stock products and warehouses.")}
                            </Text>
                        </BlockStack>
                    </Grid.Cell>
                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                        <div className='Custom__Button--Alignment'>
                            <ButtonGroup variant="segmented">
                                <Button disabled={saveLoader || getLoader} pressed={inventorySettings?.inventory_settings} onClick={() => onSettingsEnabledOrDisabled(true)} id='inventory_Btn_Enable'>
                                    {t("Enabled")}
                                </Button>
                                <Button disabled={saveLoader || getLoader} pressed={!inventorySettings?.inventory_settings} onClick={() => onSettingsEnabledOrDisabled(false)} id='inventory_Btn_Disable'>
                                    {t("Disabled")}
                                </Button>
                            </ButtonGroup>
                        </div>
                    </Grid.Cell>
                </Grid>
                <Divider />
                <div className={inventorySettings.inventory_settings ? undefined : 'card_dull'}>
                    <BlockStack gap={"400"}>
                        <InlineStack gap="200" wrap={false}>
                            <Switch className='switcherBtn' size='small'
                                id='inventory_Switch_CustomInventory'
                                checked={inventorySettings.continue_selling.enabled}
                                disabled={!inventorySettings.inventory_settings || saveLoader || getLoader}
                                onChange={(val: boolean) => {
                                    onInventorySettingsChange1("continue_selling", "enabled", val, true);
                                    let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
                                    if (JSON.stringify(savedInventorySettings['continue_selling']['enabled']) != JSON.stringify(val)) tempContextualSaveBarData.continue_selling_switcher = true;
                                    else tempContextualSaveBarData.continue_selling_switcher = false;

                                    if (!val) {
                                        tempContextualSaveBarData['continue_selling'] = false;
                                    }
                                    else {
                                        if (JSON.stringify(savedInventorySettings['continue_selling']['value']) != JSON.stringify(inventorySettings['continue_selling']['value'])) tempContextualSaveBarData.continue_selling = true;
                                        else tempContextualSaveBarData.continue_selling = false;
                                    }
                                    setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)))
                                }} />
                            <BlockStack gap="200">
                                <BlockStack gap="100">
                                    <div className='Custom__Line--Height'>
                                        <Text variant="headingSm" as="h6" id='inventory_Text_CustomInventory'>{t("Set Custom Inventory")}</Text>
                                    </div>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='inventory_Text_CustomInventryDescription'>
                                        {t("Set a custom inventory for those products that have `Continue selling when out of stock` enabled in the Shopify store.")}<Link target='_blank' url='https://support.cedcommerce.com/portal/en/kb/articles/inventory'>{t("Learn more about this here.")}</Link>
                                    </Text>
                                </BlockStack>
                                <div className='Custom__TextField--alignmnet'>
                                    <TextField
                                        id='inventory_TextField_customInventory'
                                        label=""
                                        placeholder='999'
                                        autoComplete="off"
                                        value={inventorySettings.continue_selling.value}
                                        error=""
                                        disabled={!inventorySettings.inventory_settings || saveLoader || getLoader || !inventorySettings.continue_selling.enabled}
                                        onChange={(val: any) => {
                                            onInventorySettingsChange1("continue_selling", "value", val
                                                .toString()
                                                .replace(/[\sa-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,.\/]/gi, ""), false);
                                            let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
                                            if (JSON.stringify(savedInventorySettings['continue_selling']['value']) != JSON.stringify(val)) tempContextualSaveBarData['continue_selling'] = true;
                                            else tempContextualSaveBarData['continue_selling'] = false;
                                            setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));
                                        }}
                                    />
                                </div>
                            </BlockStack>
                        </InlineStack>
                        <Divider />
                        <InlineStack gap="200" wrap={false}>
                            <Switch className='switcherBtn' size='small'
                                id='inventory_Switch_CustomInventory'
                                checked={inventorySettings.effective_inventory.enabled}
                                disabled={!inventorySettings.inventory_settings || saveLoader || getLoader}
                                onChange={(val: boolean) => {
                                    onInventorySettingsChange1("effective_inventory", "enabled", val, true);
                                    let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
                                    if (JSON.stringify(savedInventorySettings['effective_inventory']['enabled']) != JSON.stringify(val)) tempContextualSaveBarData.effective_inventory_switcher = true;
                                    else tempContextualSaveBarData.effective_inventory_switcher = false;

                                    if (!val) {
                                        tempContextualSaveBarData['effective_inventory'] = false;
                                        tempContextualSaveBarData['effective_inventory_type'] = false;
                                    }
                                    else {
                                        if (JSON.stringify(savedInventorySettings['effective_inventory']['type']) != JSON.stringify(inventorySettings['effective_inventory']['type'])) tempContextualSaveBarData.effective_inventory_type = true;
                                        else tempContextualSaveBarData.effective_inventory_type = false;

                                        if (JSON.stringify(savedInventorySettings['effective_inventory']['value']) != JSON.stringify(inventorySettings['effective_inventory']['value'])) tempContextualSaveBarData.effective_inventory = true;
                                        else tempContextualSaveBarData.effective_inventory = false;
                                    }
                                    setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));
                                    let tempErrors = JSON.parse(JSON.stringify(errors));
                                    if (val && inventorySettings.effective_inventory.type == 'none') tempErrors['effective_inventory'] = true;
                                    else tempErrors['effective_inventory'] = false;
                                    setErrors(JSON.parse(JSON.stringify(tempErrors)));
                                }} />
                            <div className={inventorySettings.effective_inventory.enabled ? undefined : 'card_dull'}>
                                <BlockStack gap="300">
                                    <BlockStack gap="100">
                                        <Text variant="headingSm" as="h6">
                                            {t("Efficient Inventory Control")}
                                        </Text>
                                        <Text variant="bodyMd" as="p">
                                            {t("Customize your preferences for streamlined selling by choosing ONE of three settings: displaying products as 'out of stock' at a threshold, selling a fixed number of products, or allocating inventory for future sales.")}
                                        </Text>
                                        <Text variant="bodyMd" as="p" tone="caution">
                                            {t("Note - Your chosen setting will be applied to all the products in your inventory.")}
                                        </Text>
                                    </BlockStack>
                                    <div className={errors.effective_inventory ? 'custom-error-description' : undefined}>
                                        <Card background="bg-surface-secondary">
                                            <BlockStack gap="400">
                                                <RadioButton
                                                    label={t("Set Fixed Inventory")}
                                                    helpText={<BlockStack gap="300">
                                                        <Text variant="bodyMd" as="p">
                                                            {t("Set the stock level of your product to a specific numerical value. This will ensure that the product is always available in the defined quantity, regardless of any external factor.")}
                                                        </Text>
                                                        {inventorySettings.effective_inventory.type === 'fixed' && <div className='Custom__TextField--alignmnet'>
                                                            <TextField
                                                                disabled={!inventorySettings.inventory_settings || !inventorySettings.effective_inventory.enabled}
                                                                label=""
                                                                autoComplete="off"
                                                                placeholder={t('Enter value')}
                                                                helpText={t("Inventory should be more than 0")}
                                                                value={inventorySettings.effective_inventory.value}
                                                                onChange={(e) => {
                                                                    let changedValue = e
                                                                        .toString()
                                                                        .replace(/[\sa-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,.\/]/gi, "");
                                                                    onInventorySettingsChange1("effective_inventory", "value", changedValue, false);

                                                                    let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
                                                                    if (JSON.stringify(savedInventorySettings['effective_inventory']['value']) != JSON.stringify(changedValue)) tempContextualSaveBarData.effective_inventory = true;
                                                                    else tempContextualSaveBarData.effective_inventory = false;
                                                                    setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));

                                                                    let tempErrors = JSON.parse(JSON.stringify(errors));
                                                                    tempErrors['fixed_inventory'] = changedValue == "" || +changedValue == 0;
                                                                    setErrors(JSON.parse(JSON.stringify(tempErrors)));
                                                                }}
                                                                error={errors.fixed_inventory}
                                                            />
                                                        </div>}
                                                    </BlockStack>}
                                                    checked={inventorySettings.effective_inventory.type === 'fixed'}
                                                    id="fixed"
                                                    onChange={(isEnabled: boolean, type: string) => {
                                                        let tempInventorySettings = JSON.parse(JSON.stringify(inventorySettings));
                                                        tempInventorySettings['effective_inventory']['value'] = "";
                                                        tempInventorySettings['effective_inventory']['type'] = type;
                                                        setInventorySettings(JSON.parse(JSON.stringify(tempInventorySettings)));

                                                        let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
                                                        if (JSON.stringify(savedInventorySettings['effective_inventory']['type']) != JSON.stringify(type)) tempContextualSaveBarData.effective_inventory_type = true;
                                                        else tempContextualSaveBarData.effective_inventory_type = false;
                                                        if (JSON.stringify(savedInventorySettings['effective_inventory']['value']) != JSON.stringify(inventorySettings['effective_inventory']['value'])) tempContextualSaveBarData.effective_inventory = true;
                                                        else tempContextualSaveBarData.effective_inventory = false;
                                                        setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));

                                                        let tempErrors = JSON.parse(JSON.stringify(errors));
                                                        if (errors['effective_inventory']) tempErrors['effective_inventory'] = false;
                                                        if (errors['threshold_inventory']) tempErrors['threshold_inventory'] = false;
                                                        if (errors['reserved_inventory']) tempErrors['reserved_inventory'] = false;
                                                        setErrors(JSON.parse(JSON.stringify(tempErrors)));
                                                    }}
                                                    disabled={!inventorySettings.inventory_settings || !inventorySettings.effective_inventory.enabled}
                                                />
                                                <RadioButton
                                                    label={t("Set Reserved Inventory")}
                                                    helpText={<BlockStack gap="300">
                                                        <Text variant="bodyMd" as="p">
                                                            {t("Setting aside a reserved inventory can set aside certain products for specific promotions or sales channels.")}
                                                        </Text>
                                                        {inventorySettings.effective_inventory.type === 'reserved' && <div className='Custom__TextField--alignmnet'>
                                                            <TextField
                                                                disabled={!inventorySettings.inventory_settings || !inventorySettings.effective_inventory.enabled}
                                                                label=""
                                                                autoComplete="off"
                                                                placeholder={t('Enter value')}
                                                                helpText={t("Inventory should be more than 0")}
                                                                value={inventorySettings.effective_inventory.value}
                                                                onChange={(e) => {
                                                                    let changedValue = e
                                                                        .toString()
                                                                        .replace(/[\sa-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,.\/]/gi, "");
                                                                    onInventorySettingsChange1("effective_inventory", "value", changedValue, false);

                                                                    let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
                                                                    if (JSON.stringify(savedInventorySettings['effective_inventory']['value']) != JSON.stringify(changedValue)) tempContextualSaveBarData.effective_inventory = true;
                                                                    else tempContextualSaveBarData.effective_inventory = false;

                                                                    setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));
                                                                    let tempErrors = JSON.parse(JSON.stringify(errors));
                                                                    tempErrors['reserved_inventory'] = changedValue == "" || +changedValue == 0;
                                                                    setErrors(JSON.parse(JSON.stringify(tempErrors)));
                                                                }}
                                                                error={errors.reserved_inventory}
                                                            />
                                                        </div>}
                                                    </BlockStack>}
                                                    id="reserved"
                                                    checked={inventorySettings.effective_inventory.type === 'reserved'}
                                                    onChange={(isEnabled: boolean, type: string) => {
                                                        let tempInventorySettings = JSON.parse(JSON.stringify(inventorySettings));
                                                        tempInventorySettings['effective_inventory']['value'] = "";
                                                        tempInventorySettings['effective_inventory']['type'] = type;
                                                        setInventorySettings(JSON.parse(JSON.stringify(tempInventorySettings)));

                                                        let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
                                                        if (JSON.stringify(savedInventorySettings['effective_inventory']['type']) != JSON.stringify(type)) tempContextualSaveBarData.effective_inventory_type = true;
                                                        else tempContextualSaveBarData.effective_inventory_type = false;
                                                        if (JSON.stringify(savedInventorySettings['effective_inventory']['value']) != JSON.stringify(inventorySettings['effective_inventory']['value'])) tempContextualSaveBarData.effective_inventory = true;
                                                        else tempContextualSaveBarData.effective_inventory = false;
                                                        setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));

                                                        let tempErrors = JSON.parse(JSON.stringify(errors));
                                                        if (errors['effective_inventory']) tempErrors['effective_inventory'] = false;
                                                        if (errors['fixed_inventory']) tempErrors['fixed_inventory'] = false;
                                                        if (errors['threshold_inventory']) tempErrors['threshold_inventory'] = false;
                                                        setErrors(JSON.parse(JSON.stringify(tempErrors)));
                                                    }}
                                                    disabled={!inventorySettings.inventory_settings || !inventorySettings.effective_inventory.enabled}
                                                />
                                                <RadioButton
                                                    label={t("Set Threshold Inventory")}
                                                    helpText={<BlockStack gap="300">
                                                        <Text variant="bodyMd" as="p">
                                                            {t("The minimum amount of inventory that you must maintain. Once the product reaches this pre-set value, it will be shown “out of stock” on Amazon.")}
                                                        </Text>
                                                        {inventorySettings.effective_inventory.type === 'threshold' && <div className='Custom__TextField--alignmnet'>
                                                            <TextField
                                                                disabled={!inventorySettings.inventory_settings || !inventorySettings.effective_inventory.enabled}
                                                                label=""
                                                                autoComplete="off"
                                                                placeholder={t('Enter value')}
                                                                helpText={t("Inventory should be more than 0")}
                                                                value={inventorySettings.effective_inventory.value}
                                                                onChange={(e) => {
                                                                    let changedValue = e
                                                                        .toString()
                                                                        .replace(/[\sa-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,.\/]/gi, "");
                                                                    onInventorySettingsChange1("effective_inventory", "value", changedValue, false);

                                                                    let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
                                                                    if (JSON.stringify(savedInventorySettings['effective_inventory']['value']) != JSON.stringify(changedValue)) tempContextualSaveBarData.effective_inventory = true;
                                                                    else tempContextualSaveBarData.effective_inventory = false;
                                                                    setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));

                                                                    let tempErrors = JSON.parse(JSON.stringify(errors));
                                                                    tempErrors['threshold_inventory'] = changedValue == "" || +changedValue == 0;
                                                                    setErrors(JSON.parse(JSON.stringify(tempErrors)));
                                                                }}
                                                                error={errors.threshold_inventory}
                                                            />
                                                        </div>}
                                                    </BlockStack>}
                                                    id="threshold"
                                                    checked={inventorySettings.effective_inventory.type === 'threshold'}
                                                    onChange={(isEnabled: boolean, type: string) => {
                                                        let tempInventorySettings = JSON.parse(JSON.stringify(inventorySettings));
                                                        tempInventorySettings['effective_inventory']['value'] = "";
                                                        tempInventorySettings['effective_inventory']['type'] = type;
                                                        setInventorySettings(JSON.parse(JSON.stringify(tempInventorySettings)));

                                                        let tempContextualSaveBarData = JSON.parse(JSON.stringify(contextualSaveBarData));
                                                        if (JSON.stringify(savedInventorySettings['effective_inventory']['type']) != JSON.stringify(type)) tempContextualSaveBarData.effective_inventory_type = true;
                                                        else tempContextualSaveBarData.effective_inventory_type = false;
                                                        if (JSON.stringify(savedInventorySettings['effective_inventory']['value']) != JSON.stringify(inventorySettings['effective_inventory']['value'])) tempContextualSaveBarData.effective_inventory = true;
                                                        else tempContextualSaveBarData.effective_inventory = false;
                                                        setContextualSaveBarData(JSON.parse(JSON.stringify(tempContextualSaveBarData)));

                                                        let tempErrors = JSON.parse(JSON.stringify(errors));
                                                        if (errors['effective_inventory']) tempErrors['effective_inventory'] = false;
                                                        if (errors['fixed_inventory']) tempErrors['fixed_inventory'] = false;
                                                        if (errors['reserved_inventory']) tempErrors['reserved_inventory'] = false;
                                                        setErrors(JSON.parse(JSON.stringify(tempErrors)));
                                                    }}
                                                    disabled={!inventorySettings.inventory_settings || !inventorySettings.effective_inventory.enabled}
                                                />
                                            </BlockStack>
                                        </Card>
                                    </div>
                                </BlockStack>
                            </div>
                        </InlineStack>
                        <Divider />
                        <InlineStack gap="200" wrap={false}>
                            <Switch className='switcherBtn' size='small'
                                id='inventory_Switch_OutStockAmazonProduct'
                                checked={inventorySettings.inactivate_product}
                                disabled={!inventorySettings.inventory_settings || saveLoader || getLoader}
                                onChange={(val: boolean) => {
                                    onInventorySettingsChange1("inactivate_product", "", val, true);
                                    if (JSON.stringify(savedInventorySettings.inactivate_product) != JSON.stringify(val)) setContextualSaveBarData({ ...contextualSaveBarData, "inactivate_product_switcher": true });
                                    else setContextualSaveBarData({ ...contextualSaveBarData, "inactivate_product_switcher": false });
                                }} />
                            <BlockStack gap="100">
                                <div className='Custom__Line--Height'>
                                    <Text variant="headingSm" as="h6" id='inventory_Text_DeleteOutOfStock'>
                                        {t("Deactivate product on Amazon")}
                                    </Text>
                                </div>
                                <BlockStack gap={'100'}>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='inventory_Text_DeleteOutOfStockDescription'>
                                       {t(" When you delete or archive a product from the sales channel or change its status from active to draft, it will automatically be marked as 'out of stock' and will become inactive on Amazon.")}
                                    </Text>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='inventory_Text_DeleteOutOfStockDescription'>
                                        <b>{t("Note:")}</b> {t("If this is turned off, the product will only be unlinked from the app without any changes to its status on Amazon. This means you may still receive orders on Amazon, even if you no longer have it in stock or plan to restock later.")}
                                    </Text>
                                </BlockStack>
                            </BlockStack>
                        </InlineStack>
                        <InlineStack gap="200" wrap={false}>
                            <Switch className='switcherBtn' size='small' defaultChecked disabled id='inventory_Switch_Warehouses' />
                            <BlockStack gap="200">
                                <BlockStack gap="100">
                                    <div className='Custom__Line--Height'>
                                        <Text variant="headingSm" as="h6" id='inventory_Text_Warehouses'>
                                            {t("Manage Warehouses")}
                                        </Text>
                                    </div>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='inventory_Text_WarehousesDescription'>
                                        {t("Control inventory storage in specific warehouses")}
                                    </Text>
                                </BlockStack>
                                {inventorySettings.warehouses.length == 0 && <Banner tone='critical'>{t("At least one warehouse should be checked. Please select at least 1 warehouse")}</Banner>}
                                {renderWarehouses()}
                            </BlockStack>
                        </InlineStack>
                    </BlockStack>
                </div>
                {lastSync && <>
                    <Divider />
                    <InlineStack blockAlign='center' align='space-between' gap="200">
                        <div className='Custom__Sync--Update'>
                            <InlineStack gap="200" wrap={false}>
                                <div>
                                    <Icon source={RefreshMajor} tone="base" />
                                </div>
                                <Text variant="headingSm" as="h6" tone='subdued'>
                                    {t("Last Sync Update")}: {lastSync}
                                </Text>
                            </InlineStack>
                        </div>
                    </InlineStack>
                </>}
            </BlockStack>
        </>
        }
    </>
}

export default DI(InventorySettings);